import Vue from 'vue';
import constant from './const';
import { filterUrlParamsFunc } from './fliterUrlParams';
import { common } from '@tencent/ceiba-base-components';

let gShareConfig = {};
const isApp = () => !!window.navigator.userAgent.match(/tgclub/i);

function getPlatform() {
  return window.Tgclub ? 'app' : '';
}

export default {
  getPlatform,
  getFlowRequestExtData: async () => {
    const zhgCode = common.tool.getQueryparams('inviteCode');
    if (zhgCode) {
      return { zhgCode };
    }
    return {};
  },
  /**
   * 初始化APP环境的分享功能
   */
  initAPPShare: async (shareConfigParams) => {
    const shareConfig =  Vue.prototype?.$storeInstance?.getters?.shareConfig ?? shareConfigParams;
    console.log('app initAPPShare from $storeInstance', shareConfig);
    gShareConfig = shareConfig;
    const initializeAppShare = () => {
      window.callShare = () => {
        window.Tgclub.shareWebPage(JSON.stringify({
          title: shareConfig?.title || '',
          summary: shareConfig?.desc || '',
          icon: shareConfig?.icon ||  constant.XY_APP_ICON,
          url: shareConfig?.link || window.location.href,
        }), () => {
        });
      };
      window.Tgclub.showFunctionButtonWithCallback(JSON.stringify({
        redpoint: 0,
        num: 0,
        iconurl: 'https://game.gtimg.cn/images/tgclub/act/a20220331/more_three_point.png',
        callback: 'window.callShare()',
      }), () => {
        window.callShare();
      });
    };

    if (window.Tgclub) {
      initializeAppShare();
    } else {
      document.addEventListener('TgclubReady', () => {
        initializeAppShare();
      });
    }
  },
  setAPPShare: async (params) => {
    gShareConfig = params;
  },
  goAPPShare: async () => {
    if (isApp() && window.Tgclub) {
      const shareCallBack = typeof gShareConfig?.callback !== 'undefined' ? gShareConfig.callback : null;
      const xinyueAppShare = {
        title: gShareConfig?.title,
        summary: gShareConfig?.desc,
        icon: constant.XY_APP_ICON,
        url: gShareConfig?.link || window.location.href,
      };
      // 心悦app ios 回调是一个函数 () =>{}
      // 心悦 安卓  回调是一个 函数字符串  "() =>{}"
      console.log('tgclub  goAPPShare xinyue  share config =', xinyueAppShare, ' shareCallBack =', shareCallBack);
      window.Tgclub.shareWebPage(JSON.stringify(xinyueAppShare), shareCallBack);
    }
  },
  disableAPPShare: async () => {
    console.log('tgclub disableAPPShare navigator.userAgent', navigator.userAgent);
    if (window.Tgclub) {
      if (navigator.userAgent.toLowerCase().indexOf('tgclub') !== -1) {
        // 隐藏分享按钮
        const { isIos } = common.platform;
        console.log('this.configurationData in hideFunctionButton ios', isIos);
        if (isIos) {
          // ios
          console.log('this.configurationData in hideFunctionButton ios');
          window.document.addEventListener(
            'TgclubReady',
            () => {
              console.log('this.configurationData in hideFunctionButton ');
              window.Tgclub.hideFunctionButton();
            },
            false,
          );
          window.Tgclub.hideFunctionButton();
          console.log('is success');
        } else {
          // if ('undefined' != typeof (window.Tgclub)) { // 安卓
          console.log('this.configurationData in hideFunctionButton');
          window.Tgclub.hideFunctionButton();
          console.log('is success');
          // }
        }
      }
    }
  },
  isAPP: isApp,
  gotoAPP: async (link) => {
    console.log('tgclub gotoAPP');

    if (isApp()) {
      return false;
    }
    let url = link || window.location.href;
    const   traceId = Vue.prototype?.$storeInstance?.getters?.reportExt?.trace_id;
    console.log('traceId = ', traceId);
    // 跳转 目标地址url  需要加上url  trace_id
    const traceIdInUrl = common.tool.getQueryparams('trace_id', url) || '';
    if (!traceIdInUrl) {
      url = common.tool.setUrlParam('trace_id', traceId, url);
    }
    url = filterUrlParamsFunc(url);
    // 跳转tgclub:// 最外层协议 需要加上 trace_id
    const schemaUrl = `tgclub://redirect?url=${encodeURIComponent(url)}&share=0&trace_id=${traceId}`;
    if (!isApp()) {
      if (!Vue.prototype.$platform.isIos && !Vue.prototype.$platform.isAndroid) {
        this.alert('仅适用IOS或Android');
        return;
      }
      if (Vue.prototype.$platform.isWX) {
        // 微信体系，使用wxJsBridge
        const timer = setTimeout(() => {
          clearTimeout(timer);
          window.WeixinJSBridge.invoke(
            'launchApplication',
            {
              schemeUrl: schemaUrl,
            },
            (res) => {
              // 微信内启动失败,跳转安装
              if (res.err_msg.indexOf('fail') !== -1) {
                if (Vue.prototype.$platform.isIos) {
                  // 微信ios
                  window.location.href = constant.IOS_DOWNLOAD_URL;
                } else if (Vue.prototype.$platform.isAndroid) {
                  // 微信安卓
                  window.location.href = constant.ANDROID_DOWNLOAD_URL;
                }
              }
            },
          );
        }, 500);
        return;
      }

      // IOS 手Q
      if (Vue.prototype.$platform.isIos && Vue.prototype.$platform.isQQ) {
        // ios的browser
        window.location.href = schemaUrl;
        setTimeout(() => {
          //  on.download && on.download();
          window.location.href = constant.IOS_DOWNLOAD_URL;
        }, 500);
      }

      // 剩下的情况 QQ 或者 安卓
      window.location.href = schemaUrl;
      // 延迟2.5秒跳转到安装地址
      const timer = setTimeout(() => {
        if (Vue.prototype.$platform.isIos) {
          window.location.href = constant.IOS_DOWNLOAD_URL;
        } else if (Vue.prototype.$platform.isAndroid) {
          window.location.href = constant.ANDROID_DOWNLOAD_URL;
        }
      }, 2500);
      // 判断是否隐藏页面,如隐藏则清除timer
      let visibilityChange = 'visibilitychange';
      if (typeof document.hidden !== 'undefined') {
        visibilityChange = 'visibilitychange';
      } else if (typeof document.mozHidden !== 'undefined') {
        visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.msHidden !== 'undefined') {
        visibilityChange = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        visibilityChange = 'webkitvisibilitychange';
      }
      document.addEventListener(
        visibilityChange,
        (event) => {
          const isHidden = Vue.prototype.$platform.isIos ? event.hidden : document.hidden;
          if (isHidden) {
            clearTimeout(timer);
          }
        },
        false,
      );
    }
  },
  openView: (options) => {
    const { url = '#' } = options;
    if (window.Tgclub) {
      window.Tgclub.openNewPage(url);
    } else {
      window.location.href = url;
    }
  },
  callAndDownLoadGame: (() => {
    const gameInfo = {};
    return async function ({ gid, isNeedDownload }) {
      console.log('------------callAndDownLoadGame', gid, isNeedDownload, Vue.prototype?.$actInfo?.activity_id);
      if (!gid || !window.Tgclub) return false;
      if (!gameInfo.packagename) {
        const response = await Vue.prototype.$axiosInstance.get(`https://wang.xinyue.qq.com/api/fly/getPkgByGid?gid=${gid}`);
        if (parseInt(response.ret, 10) === 0 && response.info.androidDownloadUrl) {
          const data = response.info || {};
          if (!data.androidPkgName) {
            console.error('download androidPkgName params empty ', response);
            return false;
          }
          data.icon = typeof data.icon === 'string' && data.icon ? JSON.parse(data.icon) : data.icon;
          gameInfo.icon = !!data.icon[108] === true ? data.icon[108] : data.icon[16];
          gameInfo.packagename = data.androidPkgName;
          gameInfo.version = data.version;
          gameInfo.gamename = data.gameName;
          gameInfo.channelid = data.channelNum;
          gameInfo.iosurl = data.IOSDownloadUrl;
          gameInfo.url = data.androidDownloadUrl;
          gameInfo.iOSPkgName = data.iosPkgName || data.androidPkgName;
          gameInfo.gid = data.gid;
          gameInfo.gameAppID = data.ext2;
          gameInfo.from = '1015';
          gameInfo.activityId = Vue.prototype?.$actInfo?.activity_id ?? 0;
          if (common.tool.getQueryparams('adreport') !== null) {
            gameInfo.from += `*${common.tool.getQueryparams('adreport')}`;
          }
        }
      }

      const jsonStr = JSON.stringify(gameInfo);

      if (common.platform.isIos) {
        window.Tgclub.downloadApp(jsonStr, (ret) => {
          /* eslint-disable-next-line */
          var jsonArr = JSON.parse(ret);
        });
        window.Tgclub.downloadViewShow(jsonStr);
        return true;
      }
      const channelId = window.Tgclub.getAppChannelInfo(gameInfo.packagename, 'channelId');
      if (channelId && typeof window.Tgclub.callExtendApp === 'function' && channelId > 0) {
        window.Tgclub.callExtendApp(`tgclub://${gameInfo.packagename}`);
        return true;
      }
      if (isNeedDownload) {
        let queryData = window.Tgclub.checkDownloadState(gameInfo.url);
        queryData = queryData ? JSON.parse(queryData) : {};
        const { state = 1 } = queryData;
        switch (state) {
          case 1:
            window.Tgclub.downloadApp(jsonStr, (ret) => {
              /* eslint-disable-next-line */
              var jsonArr = JSON.parse(ret);
            });
            Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}开始下载中`);
            break;
          case 2:
            Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}下载中`);
            break;
          case 3:
            window.Tgclub.continueDownloadApp(gameInfo.url);
            Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}下载中`);
            break;
          case 4:
            // 安装游戏
            window.Tgclub.installDownloadApp(gameInfo.url);
            Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}准备安装中`);
            break;
          default:
            break;
        }
        return false;
      }
    };
  })(),
  getAstConfig: () => ({
    shareWxAppId: 'wxf8773b4d31a9a719',
  }),
  // 构建分享回调函数 用于应对每个分享回调
  // 心悦分享不能的回调不能直接进行网络请求
  // 出触发莫名的错误
  // componentCallBackFunc 是触发回调的函数
  // caller 是触发回调的函数的对象  一般是Vue 中 this
  // params 是触发回调的参数，数组[params1,params2]
  makeAPPShareCallBack: () =>  function (funcName, thisArg) {
    if (!isApp()) {
      return funcName.bind(thisArg);
    }
    Object.defineProperty(window, 'hasTgclubShareAction', {
      set: (newValue) => {
        if (newValue > 0) {
          console.log('分享成功~~~~~~~~~~~~~~~~~~~~~~~');
          if (typeof  funcName  === 'function') {
            funcName.apply(thisArg);
          }
        }
      },
      enumerable: true,
      configurable: true,
    });
    let callback = function (ret) {
      console.log('ios 分享 ret =', ret);
      window.hasTgclubShareAction = 0;
      if (ret.result === '1') {
        window.hasTgclubShareAction = 1;
        console.log('ios 分享~suc');
      } else {
        console.log('ios分享~~失败');
      }
    };
    if (common.platform.isAndroid) {
      // 心悦app 安卓分享回调是一个字符串
      callback = `function(ret) { var jsonArr = JSON.parse(ret);window.hasTgclubShareAction = 0;
            if(jsonArr.onCheckResult == 1){window.hasTgclubShareAction = 1;console.log("分享~suc");}
            else{console.log("分享~~~失败");}}`;
    }
    return callback;
  },
};
